import { render, staticRenderFns } from "./mutation_suites.vue?vue&type=template&id=179265a0&scoped=true&"
import script from "./mutation_suites.vue?vue&type=script&lang=ts&"
export * from "./mutation_suites.vue?vue&type=script&lang=ts&"
import style0 from "./mutation_suites.vue?vue&type=style&index=0&id=179265a0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179265a0",
  null
  
)

export default component.exports